export default function DemoForm() {
  return (
    <section
      style={{
        width: '90%',
        maxWidth: '1400px',
        margin: '80px auto 60px auto', // top and bottom margin for separation
        borderRadius: '48px',
        background: 'linear-gradient(135deg, #036a12ff 0%, #20a94bff 100%)',
        boxShadow: '0 12px 48px rgba(50, 32, 200, 0.10)',
        color: 'white',
        padding: '48px 24px 40px 24px',
        textAlign: 'center'
      }}
    >
      <h2 style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '38px' }}>
        End your hunt for an effective Lead-gen partner
      </h2>
      <form style={{ width: '100%' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '18px',
            marginBottom: '18px',
            maxWidth: '900px',
            margin: '0 auto 18px auto'
          }}
        >
          <input
            type="email"
            required
            placeholder="Business Email *"
            style={{
              padding: '16px',
              fontSize: '1.25rem',
              borderRadius: '9px',
              border: 'none',
              outline: 'none',
              fontWeight: 'bold',
            }}
          />
          <input
            type="text"
            required
            placeholder="Company Name *"
            style={{
              padding: '16px',
              fontSize: '1.25rem',
              borderRadius: '9px',
              border: 'none',
              outline: 'none',
              fontWeight: 'bold',
            }}
          />
          <select
            required
            defaultValue=""
            style={{
              padding: '16px',
              fontSize: '1.25rem',
              borderRadius: '9px',
              border: 'none',
              outline: 'none',
              fontWeight: 'bold',
              color: '#888',
              background: '#fff',
            }}
          >
            <option value="" disabled>Company Size *</option>
            <option value="1-10">1-10</option>
            <option value="11-50">11-50</option>
            <option value="51-200">51-200</option>
            <option value="201-500">201-500</option>
            <option value="500+">500+</option>
          </select>
          <select
            required
            defaultValue=""
            style={{
              padding: '16px',
              fontSize: '1.25rem',
              borderRadius: '9px',
              border: 'none',
              outline: 'none',
              fontWeight: 'bold',
              color: '#888',
              background: '#fff',
            }}
          >
            <option value="" disabled>Where are you located? *</option>
            <option value="in">India</option>
            <option value="us">United States</option>
            <option value="uk">United Kingdom</option>
            <option value="eu">Europe</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div style={{ color: 'white', fontSize: '1.05rem', textAlign: 'left', maxWidth: '900px', margin: '0 auto 14px auto' }}>
          By submitting your request, you agree to our
          <a href="#" style={{ color: '#fff', textDecoration: 'underline', marginLeft: '4px', marginRight: '2px' }}>
            Terms & Conditions
          </a>
          and acknowledge that Sustainium will process your data
          in accordance with our
          <a href="#" style={{ color: '#fff', textDecoration: 'underline', marginLeft: '4px' }}>
            Privacy Policy.
          </a>
        </div>
        <div style={{ margin: '22px auto 18px auto', width: '100%', maxWidth: '900px', display: 'flex', alignItems: 'center', color: 'white', fontSize: '1.13rem' }}>
          <input type="checkbox" id="insights" style={{ width: '24px', height: '24px', marginRight: '10px' }} />
          <label htmlFor="insights">
            I want B2B marketing insights and updates. I can unsubscribe anytime. See
            <a href="#" style={{ color: '#fff', textDecoration: 'underline', marginLeft: '3px' }}>
              Privacy Policy.
            </a>
          </label>
        </div>
        <button
          type="submit"
          style={{
            background: '#66b4dbff',
            padding: '16px 44px',
            fontSize: '1.55rem',
            fontWeight: 'bold',
            borderRadius: '30px',
            border: 'none',
            color: '#fff',
            cursor: 'pointer',
            boxShadow: '0 4px 18px rgba(75,0,0,0.13)',
            marginTop: '15px'
          }}
        >
          Book a Demo
        </button>
      </form>
    </section>
  );
}
